import { alpha, Box, Stack, styled } from '@mui/material';

import { theme } from '@/design-system';
import { hoverable } from '@/shared/design-system';

export const StepContainer = styled(Stack)({
  flexDirection: 'column',
  gap: '22px',
  marginTop: '24px',
});

export const ProgressBarContainer = styled(Stack)({
  flexDirection: 'row',
  gap: '4px',
  marginTop: '8px',
  marginBottom: '4px',
});

export const ProgressSegment = styled(Box)<{ active: boolean }>(({ active }) => ({
  flex: 1,
  height: '8px',
  borderRadius: '8px',
  backgroundColor: active ? theme.colors.brand.solid : `${alpha(theme.colors.text.primary, 0.05)}`,
  transition: 'background-color 0.2s ease',
}));

export const CardContainer = styled(Stack)({
  flexDirection: 'column',
  backgroundColor: theme.colors.background.canvas,
  borderRadius: '12px',
  padding: '12px',
  gap: '16px',
});

export const SummaryRow = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 0',
  borderBottom: '1px solid #232222',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const InfoBanner = styled(Stack)<{ severity: 'warning' | 'error' | 'info' }>(
  ({ severity }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor:
      severity === 'error'
        ? 'rgba(240, 57, 44, 0.1)'
        : severity === 'warning'
          ? 'rgba(255, 220, 78, 0.05)'
          : 'rgba(65, 178, 133, 0.1)',
  }),
);

export const AffectedEntitiesPanel = styled(Stack)({
  flexDirection: 'column',
  gap: '2px',
  borderRadius: '12px',
  overflow: 'hidden',
});

export const AffectedEntitiesHeader = styled(Box)({
  padding: '16px',
  backgroundColor: theme.colors.background.canvas,
});

export const AffectedEntityRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  padding: '12px 16px',
  backgroundColor: theme.colors.background.canvas,
});

export const FooterButtons = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  borderTop: `1px solid ${theme.colors.border.default}`,
  paddingTop: '16px',
});

export const SearchResultItem = styled(Stack)<{ selected?: boolean }>(({ selected }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  padding: '12px',
  borderRadius: '8px',
  cursor: 'pointer',
  backgroundColor: selected ? 'rgba(65, 178, 133, 0.1)' : 'transparent',
  border: selected ? '1px solid #41B285' : '1px solid transparent',
  '&:hover': {
    backgroundColor: 'rgba(65, 178, 133, 0.05)',
  },
}));

export const SearchOptionButton = styled('button')({
  ...hoverable(theme, 'surfaceRaised'),
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing[12],
  padding: theme.spacing[12],
  border: 0,
  borderRadius: theme.radius[8],
  color: theme.colors.text.primary,
  background: 'transparent',
  textAlign: 'left',
  cursor: 'pointer',
});

export const FundRadioItem = styled(Stack)<{ selected?: boolean }>(({ selected }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px',
  borderRadius: '10px',
  cursor: 'pointer',
  backgroundColor: theme.colors.background.canvas,
  border: `1px solid ${selected ? theme.colors.brand.solid : 'transparent'}`,
}));
